import { render } from "./FooterComponent.vue?vue&type=template&id=e8505166"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/schiavon/Documentos/Projects/RESTRICTED_WP/frontend_administrativo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__